import React from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import CCPackageTable from '@/Atoms/CCPackageTable';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import { FontSizes, vs } from '@/Utils/Dimensions';
import { Linking, Platform, Pressable, View, TouchableOpacity } from 'react-native';
import useGetTournamentsList from '@/Hooks/TournamentsApi/useGetTournamentsList';
import { useEffect, useState, useRef } from 'react';
import useGetMyJoinedTournaments from '@/Hooks/TournamentsApi/useGetMyJoinedTournaments';
import CCButton from '@/Atoms/CCButton';
import { useMediaQuery } from '@/Hooks/useMediaQuery/useMediaQuery';
import { Image } from 'react-native';
import NoTournamentFound from '@/Assets/Images/Tournaments/no_tournament_found.svg';
import useIsMobile from '@/Hooks/useIsMobile';
import TournamentRow from './TournamentRow';
import { RFPercentage } from 'react-native-responsive-fontsize';
import Pagination from '@/Screens/Games/Pagination';
import SlideModal from '@/Atoms/SlideModal';
import CCTextInput from '@/Atoms/CCTextInput';
import CCSelect from '@/Atoms/CCSelect';
import AddNewPlayer from '@/Screens/ImportGames/AddNewPlayer';
import useFetchRegisteredPlayers from '@/Hooks/GetRegisteredPlayersApi/useFetchRegisteredPlayers';
import CCFlatlist from '@/Atoms/CCFlatlist';
import CCRadio from '@/Atoms/CCRadio/CCRadio';
import Spacer from '@/Atoms/Spacer';
import useFetchTournamentEligibility from '@/Hooks/GetTournaments/useFetchTournamentEligibility';
import useFetchTournamentQuestions from '@/Hooks/GetTournaments/useFetchTournamentQuestions';
import useSaveTournamentQuestionsResponse from '@/Hooks/GetTournaments/useSaveTournamentQuestionsResponse';
import useLoggedInUserStore from '@/Store/loggedInUserstore';
import CCLoader from '@/Atoms/CCLoader';
import useGeneratePaymentApi from '@/Hooks/SubscriptionApi/useGeneratePayment';
import { useOrderStatusApi } from '@/Hooks/BooksApi/useBooksApi';
import useJoinTournament from '@/Hooks/TournamentsApi/useJoinTournament';
import { ActivityIndicator } from 'react-native';

interface TournamentsProps {
  getTournamentDetails: (tournamentId: number) => void; // Function passed as a prop
  activeTab: string;
  userId: string;
  newLayout: boolean;
  withdraw: boolean;
}

const Tournaments: React.FC<TournamentsProps> = ({
  getTournamentDetails,
  activeTab,
  userId,
  newLayout,
  withdraw,
}) => {
  const isMobileOrTab = useIsMobile();
  const navigation = useNavigation();
  // Mock data for the tournaments
  const headers = ['Time', 'Name', 'Starting in', 'Rounds', '', ''];
  const mobileHeaders = ['Time', 'Tournament Details', ''];
  const [tableData, setTableData] = useState([]);
  const [tabSwitch, setTabSwitch] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [show, setShow] = useState(false);
  const [stage, setStage] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');

  const userData = useLoggedInUserStore(state => state.userData);
  const [selectedTournament, setSelectedTournament] = useState<any | null>(
    null,
  );

  const handleOnSuccessGeneratePayment = (paymentUrlData: any) => {
    if (paymentUrlData?.data?.content?.payment_links?.web) {
      Linking.openURL(paymentUrlData?.data?.content?.payment_links?.web);
    } else if (paymentUrlData?.data?.success) {
      setShow(false);
      fetchTournaments({ limit: 25, offset: 0, userId: userId });
    }
  };

  const handleOnErrorGeneratePayment = (error: any) => {
    console.log('Error generating payment:', error);
  };

  const {
    mutate: generatePayment,
    data: paymentUrlData,
    error: paymentUrlDataError,
    isLoading: paymentLoading,
  } = useGeneratePaymentApi(
    handleOnSuccessGeneratePayment,
    handleOnErrorGeneratePayment,
  );

  const {
    mutate: checkEligibility,
    data: eligibilityData,
    isLoading: eligibilityLoading,
  } = useFetchTournamentEligibility();

  const {
    mutate: getQuestions,
    data: questionsData,
    isLoading: questionLoading,
  } = useFetchTournamentQuestions();

  useEffect(() => {
    const payload = {
      tournament_id: String(selectedTournament?.registration_tid),
      user_id: Number(userId),
    };
    if (eligibilityData?.status) {
      getQuestions(payload);
      setStage(1);
      setShow(true);
    } else if (eligibilityData?.club_id) {
      setErrorMessage(eligibilityData?.error);
      payload.tournament_id = eligibilityData?.club_id;
      if (selectedTournament.club) {
        setSelectedTournament({
          ...selectedTournament.club,
          registration_tid: eligibilityData?.club_id,
        });
      }
      checkEligibility({
        mobile_number: userData?.mobile_number,
        player_id: userData?.player,
        registration_tid: Number(payload.tournament_id),
      });
      // getQuestions(payload);
      // setStage(1);
      setShow(true);
    }
  }, [eligibilityData]);

  useEffect(() => {
    if (questionsData?.questions && !questionsData?.questions?.length) {
      setStage(2);
    }
  }, [questionsData]);

  const paginate = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const tournamentData = [
    {
      time: '10:00 AM',
      name: 'Rapid Swiss Tournament',
      startingIn: '2 hrs',
      players: 40,
      fees: '₹1000',
      url: 'https://example.com/join/1',
      id: 1,
    },
    {
      time: '12:00 PM',
      name: 'Blitz Open Tournament',
      startingIn: '1 hr',
      players: 20,
      fees: 'Free',
      url: 'https://example.com/join/2',
      id: 2,
    },
    {
      time: '2:00 PM',
      name: 'Classic Chess Tournament',
      startingIn: '3 hrs',
      players: 50,
      fees: '₹500',
      url: 'https://example.com/join/3',
      id: 3,
    },
  ];

  const tournamentsDataref = useRef(tournamentData);

  const {
    mutate: fetchTournaments,
    data: tournamentsData,
    isLoading: listLoading,
    isError,
    error,
  } = useGetTournamentsList();

  const { mutate: fetchMyTournaments, data: myTournamentsData } =
    useGetMyJoinedTournaments();

  const POLL_INTERVAL = 300000; // Poll every 5 min

  useEffect(() => {
    let interval;
    setTabSwitch(true);
    setCurrentPage(1);
    const fetchData = () => {
      if (activeTab === 'upcoming' || withdraw) {
        fetchTournaments({ limit: 25, offset: 0, userId: userId });
      } else if (activeTab === 'registered') {
        fetchMyTournaments({ userId });
      }
    };

    if (userId) {
      fetchData();
    } // Fetch data immediately

    // Start polling only for "upcoming" tab
    if (activeTab === 'upcoming') {
      interval = setInterval(fetchData, POLL_INTERVAL);
    }

    return () => {
      if (interval) {
        clearInterval(interval); // Cleanup on unmount or tab change
      }
    };
  }, [activeTab, withdraw, userId]);

  type RouteParams = { order_id?: string };
  const route = useRoute();
  const { order_id } = (route.params || {}) as RouteParams;

  // const orderStatusSuccess = data => {
  //   if (data.status === 'success') {
  //     fetchTournaments({ limit: 25, offset: 0, userId: userId });
  //   }
  // };
  const { mutate: orderBookStatus, data: orderStatusResponse, isLoading: isStatusLoading } =
    useOrderStatusApi();

  const { mutate: joinTournament } = useJoinTournament(() => {
    fetchTournaments({ limit: 25, offset: 0, userId: userId });
  });

  useEffect(() => {
    if (order_id) {
      setShow(true);
      setStage(4);
      orderBookStatus({ order_id });
    }
  }, [order_id]);

  useEffect(() => {
    if (orderStatusResponse?.status === 'CHARGED' && selectedTournament?.parent_id) {
      joinTournament({
        tournamentId: Number(selectedTournament?.parent_id),
        playerId: Number(userData?.player),
      });
    } else if (orderStatusResponse?.status === 'CHARGED') {
      joinTournament({
        tournamentId: Number(selectedTournament?.id),
        playerId: Number(userData?.player),
      });
    }
  }, [orderStatusResponse, selectedTournament]);

  useEffect(() => {
    // console.log('tournamentsData is :', tournamentsData);
    let tournamentsList =
      activeTab == 'upcoming' ? tournamentsData : myTournamentsData;

    if (activeTab === 'upcoming' && tournamentsData?.data) {
      // console.log('asdf', tournamentsDataref.current, tournamentsData?.data);
      // if (
      //   tournamentsData?.data &&
      //   (tournamentsDataref.current != tournamentsData?.data || tabSwitch)
      // ) {
      const itemsPerPage = 10;
      const allData = [...tournamentsData?.data];
      const fixedTournamentIndex = allData.findIndex(item => item.id === 1591);
      const fixedTournament =
        fixedTournamentIndex !== -1
          ? allData.splice(fixedTournamentIndex, 1)[0]
          : null;
      const totalItems = allData.length + (fixedTournament ? 1 : 0);
      setTotalPages(Math.ceil(totalItems / itemsPerPage));

      const paginatedData: any[] = [];

      if (currentPage === 1) {
        if (fixedTournament) paginatedData.push(fixedTournament);
        paginatedData.push(
          ...allData.slice(0, itemsPerPage - paginatedData.length),
        );
      } else {
        const startIndex =
          (currentPage - 1) * itemsPerPage - (fixedTournament ? 1 : 0);
        const endIndex = startIndex + itemsPerPage;
        paginatedData.push(...allData.slice(startIndex, endIndex));
      }
      setTableData(paginatedData);
      tournamentsDataref.current = tournamentsData.data;
      setTabSwitch(false);
      // }
    } else {
      const itemsPerPage = 10;
      myTournamentsData?.data.sort((a, b) => {
        const dateA = new Date(a.start_date);
        const dateB = new Date(b.start_date);

        // Extract only the date part (YYYY-MM-DD) for comparison
        const dateOnlyA = dateA.toISOString().split('T')[0];
        const dateOnlyB = dateB.toISOString().split('T')[0];

        // Sort by date (descending order)
        if (dateOnlyA > dateOnlyB) {
          return -1;
        }
        if (dateOnlyA < dateOnlyB) {
          return 1;
        }

        // If dates are the same, sort by time (ascending order)
        return dateA.getTime() - dateB.getTime();
      });

      const totalItems = myTournamentsData?.data.length;

      setTotalPages(Math.ceil(totalItems / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const paginatedData = myTournamentsData?.data.slice(startIndex, endIndex);
      setTableData(paginatedData);
    }
  }, [currentPage, tournamentsData, myTournamentsData]);

  const timeControlToSvgAndColor = {
    Bullet: {
      svg: (
        <Image
          source={require('@/Assets/Images/Svgs/Bullet.svg')}
          style={{
            width: 20,
            height: 20,
          }}
        />
      ),
      color: '#937ADB47',
    },
    Bolt: {
      svg: (
        <Image
          source={require('@/Assets/Images/Svgs/Bolt.svg')}
          style={{
            width: 20,
            height: 20,
          }}
        />
      ),
      color: '#67B3E147',
    },
    Rapid: {
      svg: (
        <Image
          source={require('@/Assets/Images/Svgs/Rapid.svg')}
          style={{
            width: 20,
            height: 20,
          }}
        />
      ),
      color: '#DB7ACC48',
    },
    Snail: {
      svg: (
        <Image
          source={require('@/Assets/Images/Svgs/Snail.svg')}
          style={{
            width: 20,
            height: 20,
          }}
        />
      ),
      color: '#3DAB9E47',
    },
  };

  // Handle row press (e.g., navigate to tournament details)
  const handleRowPress = (tournament: any, showRegisterModal: boolean) => {
    const tournamentId = tournament.id;
    setSelectedTournament(tournament);
    setErrorMessage('');
    if (showRegisterModal) {
      if (tournament.is_series) {
        setStage(3); // Stage 3 for Series Registration Modal
        setShow(true);
      } else {
        checkEligibility({
          mobile_number: userData?.mobile_number,
          player_id: userData?.player,
          registration_tid: tournament?.registration_tid,
        });
      }
    } else {
      // @ts-ignore
      navigation.setParams({
        tournamentId,
        tournamentName: tournament?.name,
      });
      getTournamentDetails(tournamentId);
    }
  };

  const handlePayment = (category, amount) => {
    const payload = {
      category_str: category,
      customer_id: userData?.user_id,
      email: userData?.email,
      mobile_number: userData?.mobile_number,
      player_id: userData?.player,
      tournament_id: selectedTournament.cct_id,
      amount,
      return_url: window.location.href,
    };
    if (selectedTournament?.parent_id && selectedTournament?.is_series) {
      payload.child_tournament_id = Number(selectedTournament.id);
    }
    generatePayment(payload);
  };

  const sortedTournaments = tableData?.slice()?.sort((a, b) => {
    if (a.id === 1591) return -1;
    if (b.id === 1591) return 1;
    return 0;
  });

  return (
    <Box
      alignItems="center"
      justifyContent="center"
      style={{
        borderRadius: 8,
        backgroundColor: CCColors.White,
        height: !userId || listLoading ? '50%' : 'auto',
      }}>
      {tableData && tableData.length > 0 ? (
        <Box
          flexDirection="column"
          flex={1}
          style={{
            width: '100%',
            marginHorizontal: !isMobileOrTab && 5,
            padding: isMobileOrTab ? 10 : 20,
          }}>
          <Box
            flexDirection="row"
            style={{ marginBottom: 10 }}
            alignItems="center">
            <CCText
              color={CCColors.TextColor.LightGrey}
              fontWeight={500}
              fontSize={!isMobileOrTab ? FontSizes[14] : RFPercentage(1.8)}
              style={{ marginRight: '20%' }}>
              Time
            </CCText>
            <CCText
              color={CCColors.TextColor.LightGrey}
              fontWeight={500}
              fontSize={!isMobileOrTab ? FontSizes[14] : RFPercentage(1.8)}>
              Tournament Details
            </CCText>
          </Box>
          <Box
            style={{
              borderTopColor: CCColors.BorderLight,
              borderTopWidth: 1,
            }}
            flexDirection="column">
            {sortedTournaments?.map((item, rowIndex) => {
              return (
                <>
                  <TournamentRow
                    item={item}
                    rowIndex={rowIndex}
                    activeTab={activeTab}
                    handleRowPress={handleRowPress}
                    timeControlToSvgAndColor={timeControlToSvgAndColor}
                    isMobileOrTab={isMobileOrTab}
                    userId={userId}
                    userData={userData}
                  />
                </>
              );
            })}
            <SlideModal
              type="side"
              visible={show}
              modalHeaderTitle={
                stage === 4 ? 'Payment Status' : stage === 3 ? 'Series Registration' : stage === 1 ? 'Answer Questions' : 'Select Entry Fee'
              }
              onClose={() => {
                setShow(false);
                setStage(0);
              }}>
              <View style={{ padding: 30 }}>
                {(eligibilityLoading || questionLoading || isStatusLoading) && (
                  <CCLoader loading />
                )}
                {stage === 4 ? (
                  !isStatusLoading && (
                    <PaymentStatusModal
                      status={orderStatusResponse?.status}
                      onClose={() => {
                        setShow(false);
                        setStage(0);
                      }}
                    />
                  )
                ) : stage === 3 ? (
                  <SeriesRegistrationModal
                    tournament={selectedTournament}
                    userData={userData}
                    onProceed={() => {
                      checkEligibility({
                        mobile_number: userData?.mobile_number,
                        player_id: userData?.player,
                        registration_tid: selectedTournament?.registration_tid,
                      });
                    }}
                  />
                ) : stage === 2 ? (
                  <EntryFeeSelect
                    categories={eligibilityData?.category_fees || {}}
                    errorMessage={errorMessage}
                    handlePayment={handlePayment}
                  />
                ) : (
                  <QuestionList
                    questions={questionsData?.questions}
                    userData={userData}
                    selectedTournament={selectedTournament}
                    setStage={setStage}
                  />
                )}
              </View>
            </SlideModal>
          </Box>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            paginate={paginate}
          />
        </Box>
      ) : !userId || listLoading ? (
        <Box alignItems="center" justifyContent="center">
          <ActivityIndicator color={CCColors.BlueAqua} size={'large'} />
        </Box>
      ) : (
        <View
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
            gap: 20,
            marginTop: isMobileOrTab ? 0 : '10%',
          }}>
          <Image
            resizeMode="contain"
            style={{
              width: isMobileOrTab ? Platform.OS === 'web' && 100 : 180,
              height: isMobileOrTab ? Platform.OS === 'web' && 100 : 180,
            }}
            source={NoTournamentFound}
          />
          <CCText fontSize={24} style={{ lineHeight: 24, fontWeight: 500 }}>
            Nothing scheduled today
          </CCText>
        </View>
      )}
    </Box>
  );
};

const QuestionList = ({
  questions = [],
  selectedTournament,
  userData,
  setStage,
}) => {
  const [responses, setResponses] = useState<any>({});

  const { mutate: submitQuestions, data: submitResponse } =
    useSaveTournamentQuestionsResponse();

  useEffect(() => {
    if (submitResponse) {
      setStage(2);
    }
  }, [submitResponse]);

  const handleChange = (index: number, value: string) => {
    setResponses(prev => ({
      ...prev,
      [index]: value,
    }));
  };

  return (
    <Box>
      <CCFlatlist
        data={questions}
        renderItem={({ item }) => (
          <Box>
            <CCText>{item?.question_text}</CCText>
            <CCTextInput onChangeText={text => handleChange(item.id, text)} />
          </Box>
        )}
        keyExtractor={(item, index) => index.toString()}
      />
      <Spacer spacing={vs(20)} />
      <CCButton
        type="fill"
        disabled={
          Object.keys(responses).length !==
          questions?.filter(t => t.is_mandatory).length
        }
        onPress={() => {
          submitQuestions({
            tournament_id: selectedTournament?.registration_tid,
            player_id: userData?.player,
            responses: Object.entries(responses).map(
              ([question_id, response]) => ({
                question_id: Number(question_id),
                response: response as string,
              }),
            ),
            sender: userData?.mobile_number,
          });
        }}>
        Proceed
      </CCButton>
    </Box>
  );
};

const EntryFeeSelect = ({ errorMessage, categories, handlePayment }) => {
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  return (
    <View>
      <Spacer spacing={vs(10)} />
      <CCText color={CCColors.Primary.Aqua} fontSize={FontSizes[16]}>
        {errorMessage}
      </CCText>
      <Spacer spacing={vs(30)} />
      <CCFlatlist
        data={Object.keys(categories).map(key => ({
          label: `INR ${categories[key]} / ${key}`,
          value: categories[key],
        }))}
        renderItem={({ item }) => (
          <CCRadio
            label={item?.label}
            value={item?.value}
            selected={selectedCategory?.label === item.label}
            onToggle={() => {
              setSelectedCategory(item);
            }}
            unselectedColor={CCColors.TextColor.Dark}
            style={{ marginBottom: vs(10) }}
          />
        )}
        keyExtractor={(item, index) => index.toString()}
      />
      <Spacer spacing={vs(20)} />
      <CCButton
        type="fill"
        onPress={() =>
          handlePayment(selectedCategory?.label, selectedCategory?.value)
        }>
        Proceed to Payment
      </CCButton>
    </View>
  );
};

const SeriesRegistrationModal = ({ tournament, onProceed, userData }) => {
  return (
    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Spacer spacing={vs(20)} />
      <Box alignItems="center" justifyContent="center">
        <Image
          source={require('@/Assets/Images/Svgs/Tournaments.svg')}
          style={{ width: 150, height: 150 }}
          resizeMode="contain"
        />
      </Box>
      <Spacer spacing={vs(20)} />
      <CCText fontSize={20} fontWeight={600} style={{ textAlign: 'center', lineHeight: 28 }}>
        Register for Tournament Series
      </CCText>
      <Spacer spacing={vs(10)} />
      <CCText fontSize={16} color={CCColors.TextColor.LightGrey} style={{ textAlign: 'center', lineHeight: 24 }}>
        {`This tournament is part of the "${tournament?.parentName || tournament?.name}" series. You need to be registered in the series to play.`}
      </CCText>
      <CCButton
        type="fill"
        onPress={() => Linking.openURL('https://cc-tournaments.s3.ap-south-1.amazonaws.com/brochures/50108.pdf')}
      >
        View Brochure
      </CCButton>
      <Spacer spacing={vs(30)} />

      <Box style={{ width: '100%' }}>
        {/* <CCButton
          type="fill"
          onPress={onProceed}
        >
          Proceed to Register
        </CCButton> */}
        <Spacer spacing={vs(15)} />
        <CCButton
          type="outline"
          onPress={() => {
            const redirectUrl = `https://circlechess.com/registration?id=${tournament.cct_id}`;
            Linking.openURL(redirectUrl);
          }}
          style={{ borderColor: '#25D366' }}
        >
          <CCText color="#25D366" fontWeight={600}>Register on WhatsApp</CCText>
        </CCButton>
      </Box>
    </View>
  );
};

const PaymentStatusModal = ({ status, onClose }) => {
  const isSuccess = status === 'CHARGED';
  return (
    <View style={{ alignItems: 'center', justifyContent: 'center' }}>
      <Spacer spacing={vs(20)} />
      <Box alignItems="center" justifyContent="center">
        <MaterialCommunityIcons
          name={isSuccess ? 'check-circle' : 'close-circle'}
          size={56}
          color={isSuccess ? CCColors.Green : CCColors.Red}
        />
      </Box>
      <Spacer spacing={vs(30)} />
      <CCText
        fontSize={22}
        fontWeight={600}
        style={{ textAlign: 'center', lineHeight: 30 }}>
        {isSuccess ? 'Payment Successful!' : 'Payment Failed'}
      </CCText>
      <Spacer spacing={vs(15)} />
      <CCText
        fontSize={16}
        color={CCColors.TextColor.LightGrey}
        style={{ textAlign: 'center', lineHeight: 24 }}>
        {isSuccess
          ? 'Your registration has been confirmed. Good luck with your tournament!'
          : 'We could not process your payment at this moment. Please try again later or contact support if the issue persists.'}
      </CCText>
      <Spacer spacing={vs(40)} />
      <CCButton type="fill" onPress={onClose} style={{ width: '100%' }}>
        {isSuccess ? 'Great!' : 'Close'}
      </CCButton>
    </View>
  );
};

export default Tournaments;
